import React from 'react'

export default function Loader() {
    return (
        <div className="h-[450px] flex items-center justify-center">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
        </div>
    )
}
